module.exports = __webpack_public_path__ + "static/media/duckduckgo.1a837031.svg";